export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En cours"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terminé"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En attente"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivant"])}
}